export default "__VITE_ASSET__DKn2Hd$S__"